const Cover = () => {
  return (
    <section id="cover" className="cover">
      <p>EFA Programador Informático - NST PROG-28</p>
      <h1 className="titlePRA">Meu Portfólio Reflexivo de Aprendizagem</h1>
        <div className="formando-formador">
          <p><strong>Formando:</strong> Monique Ruggeri</p>
          <p>|</p> 
          <p><strong>Formador:</strong> Inês Santos</p>
        </div>
      <div className="footer">
        <p>Escola Marquês de Pombal - Belém</p>
        <p><strong>2025/2026</strong></p>
      </div>
    </section>
  );
};

export default Cover;
